import { render, staticRenderFns } from "./NormalArticle.vue?vue&type=template&id=bc7e1ec2&scoped=true"
import script from "./NormalArticle.vue?vue&type=script&lang=js"
export * from "./NormalArticle.vue?vue&type=script&lang=js"
import style0 from "./NormalArticle.vue?vue&type=style&index=0&id=bc7e1ec2&prod&lang=less"
import style1 from "./NormalArticle.vue?vue&type=style&index=1&id=bc7e1ec2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e1ec2",
  null
  
)

export default component.exports